import { Show, SimpleShowLayout, TextField } from "react-admin";
import BackActions from "../../action/BackActions";

const OrgShowTitle: any = ({ record }) => {
  return <span>{record ? `${record.name}` : ""}</span>;
};

export const OrgShow = (props) => (
  <Show
    title={<OrgShowTitle />}
    actions={<BackActions {...props} />}
    {...props}
  >
    <SimpleShowLayout>
      <TextField source="name" label="portal.label.orgName" />
      <TextField source="code" label="portal.label.partCode" />
      <TextField source="partType" label="portal.label.partType" />
    </SimpleShowLayout>
  </Show>
);
